export default "__VITE_ASSET__BIBq85lp__"